import styled from "styled-components"

export const BadgeContainer = styled.div`
  position: absolute;
  height: 30px;
  padding: 5px 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 3px;
  text-transform: uppercase;
  font-size: 12px;
  z-index: 10;
  top: 10px;
  right: 10px;
  color: ${({ theme: { colors } }) => colors.white};
  font-weight: ${({ theme: { fontWeight } }) => fontWeight.semiBold};
  background-color: ${({ color }) => color};
`

BadgeContainer.displayName = "BadgeContainer"
